import { useState, useEffect } from 'react';
import { 
    default as MorningstarAnalystRatingExternal,
} from "src/MarketDataComponents/MorningstarAnalystRatingExternal";

export default function MorningstarAnalystRating({instrumentInfo, ratings, morningstar}) {
    const url = `${morningstar.baseUrl}/${morningstar.solutionKey}/snapshotpdf/default.aspx?LanguageId=en-GB&Id=${instrumentInfo.msid}&ms-redirect-path=%2F1c6qh1t6k9default.aspx`;
    const analystReportUrl = `${morningstar.baseUrl}/${morningstar.solutionKey}/snapshotresearchpdf/default.aspx?LanguageId=en-GB&Id=${instrumentInfo.msid}&ms-redirect-path=%2F1c6qh1t6k9default.aspx`;
    return <>
        <div className="card z-depth-0 margin-0">
            <div className="card-content padding-top-0-sm padding-right-0-sm padding-bottom-30-sm padding-left-0-sm padding-bottom-0">
                {ratings && ratings.analystRatingLabel ? <>
                    <h2 className="card-title" data-testid="morningStarAnalystRatingHeader">
                        Morningstar Medalist Rating
                        <sup className="h7"><small>TM</small></sup>
                    </h2>
                    <MorningstarAnalystRatingExternal rating={ratings.analystRatingLabel.toLowerCase().replace(' ','')} />
                    <hr/>
                    <p className="margin-top-10">
                        <a target="_blank" href={analystReportUrl} className="c-btn waves-effect waves-light button-outline button button--outline-darkblue c-btn-small no-arrow" rel="noreferrer" data-testid="morningStarAnalystReportDocLink">
                            <i className="far fa-file-alt" />&nbsp;
                            Morningstar analyst document
                        </a>
                    </p>

                </> : null}
                <p className="margin-0">
                    <a target="_blank" href={url} className="c-btn waves-effect waves-light button-outline button button--outline-darkblue c-btn-small no-arrow" rel="noreferrer" data-testid="morningStarReportDocLink">
                        <i className="far fa-file-alt" />&nbsp;
                        Morningstar report document
                    </a>
                </p>
                

            </div>
        </div>
    </>

}